/* global theme */

if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.stickyAtcButton = this.querySelector('[data-sticky-atc-submit]');
      this.handleStickyAtcClick = this.handleStickyAtcClick.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
      if (this.productSection) this.productSection.addEventListener('on:variant:change', this.handleVariantChange);

      if (this.stickyAtcButton) {
        this.stickyAtcButton.addEventListener('click', this.handleStickyAtcClick);
      }

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      if (this.stickyAtcButton) {
        this.stickyAtcButton.removeEventListener('click', this.handleStickyAtcClick);
      }
    }

    /**
     * Submits the active product form so the selected variant, quantity, line-item
     * properties, and the theme's normal cart-drawer flow are all preserved.
     */
    handleStickyAtcClick() {
      const addToCartButton = this.productForm && this.productForm.querySelector('[name="add"]');
      if (addToCartButton && !addToCartButton.disabled) addToCartButton.click();
    }

    /**
     * TWRG 2026-09-15: keep the sticky price on the selected variant. variant-picker updates the main
     * price before it dispatches on:variant:change, so copy it. Hide-price products render no price in
     * either place, so nothing is copied for them.
     */
    handleVariantChange() {
      const main = this.productSection && this.productSection.querySelector('.product-info__price > .price');
      const mine = this.querySelector('.card__info .price');
      if (!main || !mine) return;
      mine.innerHTML = main.innerHTML;
      ['price--on-sale', 'price--sold-out'].forEach((c) => mine.classList.toggle(c, main.classList.contains(c)));
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
